import { styled } from '@mui/material'
import { ReactComponent as SwitchIconSvg } from './switch-icon.svg'

export const ConvertIcon = styled(SwitchIconSvg)`
  margin-left: 2px;
  width: 12px;
  height: 12px;
  circle {
    fill: ${(props) => props.theme.color.text20};
  }
  path {
    fill: ${(props) => props.theme.color.text70};
  }
`
